var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card__container"},[_vm._t("default")],2),(_vm.showClose)?_c('HdButton',{staticClass:"card__close-button",attrs:{"icon-src":_vm.close,"aria-label":_vm.$t('GENERAL.REMOVE'),"type":"button","modifier":"tertiary"},on:{"click":function($event){return _vm.$emit('close')}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }